/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_Api_Errors_Assignee_Not_AdminInputs */

const nl_tickets_api_errors_assignee_not_admin = /** @type {(inputs: Tickets_Api_Errors_Assignee_Not_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze gebruiker is geen beheerder.`)
};

/**

* @param {Tickets_Api_Errors_Assignee_Not_AdminInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_api_errors_assignee_not_admin = /** @type {((inputs?: Tickets_Api_Errors_Assignee_Not_AdminInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_Api_Errors_Assignee_Not_AdminInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_api_errors_assignee_not_admin(inputs)
});
export { tickets_api_errors_assignee_not_admin as "tickets.api_errors.assignee_not_admin" }